/**
 * @generated SignedSource<<e6da5c769dd3368216f57d38997f5e8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPaymentView_buyer$data = {
  readonly wallet: {
    readonly paymentMethods: ReadonlyArray<{
      readonly paymentMethod: {
        readonly __typename: "ACH";
        readonly token: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountView_bankAccount">;
      } | {
        readonly __typename: "CreditCard";
        readonly token: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCardView_creditCard">;
      } | {
        readonly __typename: "PayPalAccount";
        readonly token: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"CheckoutPayPalView_payPalAccount">;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "CheckoutPaymentView_buyer";
};
export type CheckoutPaymentView_buyer$key = {
  readonly " $data"?: CheckoutPaymentView_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPaymentView_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPaymentView_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Wallet",
      "kind": "LinkedField",
      "name": "wallet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WalletPaymentMethod",
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "paymentMethod",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "CheckoutCreditCardView_creditCard"
                    },
                    (v0/*: any*/)
                  ],
                  "type": "CreditCard",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "CheckoutPayPalView_payPalAccount"
                    },
                    (v0/*: any*/)
                  ],
                  "type": "PayPalAccount",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "CheckoutBankAccountView_bankAccount"
                    },
                    (v0/*: any*/)
                  ],
                  "type": "ACH",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "00d58d298c019eee17efadb1806008e1";

export default node;
